
// Live Support Toggle
const oaToggleLiveSupport = (e) => {
    e.preventDefault();
    const supportPopup = document.querySelector(".oa-live-support__popup");
    if (supportPopup) {
        if (supportPopup.classList.contains("active")){
            supportPopup.classList.remove("active");
        }else{
            supportPopup.classList.add("active");
        }
    }
};

// Init Click Events
export const oaInitLiveSupport = () => {
    const supportIcon = document.querySelector(".oa-live-support__icon");
    if (supportIcon){
        supportIcon.addEventListener("click", oaToggleLiveSupport);
    }
    const closeIcon = document.querySelector(".oa-live-support__close-widget");
    if (closeIcon){
        closeIcon.addEventListener("click", oaToggleLiveSupport);
    }
};
// Initialize Live Chat Function
export const initLiveChat = () => {
    window.__lc = window.__lc || {};
    window.__lc.license = 11661638;
    window.__lc.integration_name = 'Wordpress';
    ;(function(n,t,c){function i(n){return e._h?e._h.apply(null,n):e._q.push(n)}var e={_q:[],_h:null,_v:"2.0",on:function(){i(["on",c.call(arguments)])},off:function(){i(["off",c.call(arguments)])},get:function(){if(!e._h)throw new Error("[LiveChatWidget] You can't use getters before load.");return i(["get",c.call(arguments)])},call:function(){i(["call",c.call(arguments)])},init:function(){var n=t.createElement("script");n.async=!0,n.type="text/javascript",n.src="https://cdn.livechatinc.com/tracking.js",t.head.appendChild(n)}};!n.__lc.asyncInit&&e.init(),n.LiveChatWidget=n.LiveChatWidget||e}(window,document,[].slice));

    LiveChatWidget.call("hide"); // Hide when initialization

    setTimeout(function(){
        if ( document.getElementById("chat-widget-container") ){
            LiveChatWidget.on('visibility_changed', onVisibilityChanged);
            var liveChatInc = document.getElementById("chat-widget-container");
            liveChatInc.classList.add('kts-live-chat-deactive');
        }
    }, 2000);
};

const onVisibilityChanged = (data) => {
    var liveChatInc = document.getElementById("chat-widget-container");
    var oaLiveSupportWidget = document.getElementById("oa-live-support-widget");
    switch (data.visibility) {
        case 'maximized':
            liveChatInc.classList.add('kts-live-chat-active');
            liveChatInc.classList.remove('kts-live-chat-deactive');
            oaLiveSupportWidget.style.display = 'none';
            break
        case 'minimized':
            liveChatInc.classList.add('kts-live-chat-deactive');
            liveChatInc.classList.remove('kts-live-chat-active');
            oaLiveSupportWidget.style.display = 'block';
            LiveChatWidget.call("hide");
            break
        case 'hidden':
            liveChatInc.classList.add('kts-live-chat-hidden');
            oaLiveSupportWidget.style.display = 'block';
            LiveChatWidget.call("hide");
            break
    }
};

// Init when click on Live Chat
export const initLiveChatClick = () => {
    const liveChatEl = document.querySelector(".oa-live-support__service");
    if ( liveChatEl && liveChatEl.classList.contains("oa-live-support__service--livechat") ){
        liveChatEl.addEventListener("click", (e) => {
            e.preventDefault();
            // if (LiveChatWidget){
            //     const oaLiveChatWidget = document.getElementById("oa-live-support-widget");
            //     LiveChatWidget.call("maximize");
            //     oaLiveChatWidget.style.display = "none";
            // }

            const oaLiveChatWidget = document.getElementById("oa-live-support-widget");
            if( oaLiveChatWidget ) {
                oaLiveChatWidget.style.display = "none";
            }
        });
    }
};
export const initCloseWidget = () => {
    document.addEventListener("click", (event) => {
        var targetElement = event.target;
        if (!targetElement.closest("#oa-live-support-widget") ){
            const supportPopup = document.querySelector(".oa-live-support__popup");
            if (supportPopup && supportPopup.classList.contains("active")){
                supportPopup.classList.remove("active");
            }
        }
    })
};